import { ItemContainerCreator } from "./item-container-creator";
import { GraphicColumnGrid, FixedDimension, PercentDimension } from "../../../../../web-graphics";

export class ColumnGridCreator extends ItemContainerCreator {
  constructor(commonSettings) {
    super(commonSettings);
  }

  static prepareSettings(settings) {
    settings.location = {
      x: settings.x?.copy() ?? new FixedDimension(0),
      y: settings.y?.copy() ?? new FixedDimension(0)
    };
    settings.size = {
      width: settings.width?.copy() ?? new PercentDimension(1),
      height: settings.height?.copy() ?? new PercentDimension(1)
    };
    settings.parent = {
      ref: settings._parentObject
    };
    for (let columnIndex = 0; columnIndex < settings.columns.length; columnIndex++) {
      const columnSettings = settings.columns[columnIndex];
      if (columnSettings.width === undefined) {
        columnSettings.width = new PercentDimension(1);
      }
      if (columnSettings.rowsSpace === undefined) {
        columnSettings.rowsSpace = new FixedDimension(0);
      }
      for (let rowIndex = 0; rowIndex < columnSettings.rows.length; rowIndex++) {
        const rowSettings = columnSettings.rows[rowIndex];
        if (rowSettings.height === undefined) {
          rowSettings.height = new PercentDimension(1);
        }
      }
    }
  }

  static createItems(columnsSettings, viewObjectCreators, columnGridObject, canvasObject, idGenerator, creator) {
    if (columnsSettings === undefined || !Array.isArray(columnsSettings)) {
      return;
    }
    let calllbackArray = creator.callbacks.get("beforeAddItems");
    calllbackArray.forEach(callback => callback(columnGridObject, columnsSettings, creator));
    for (let columnIndex = 0; columnIndex < columnsSettings.length; columnIndex++) {
      let columnSettings = columnsSettings[columnIndex];
      let rows = columnSettings.rows ?? [];
      for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
        ItemContainerCreator.createItem(
          rows[rowIndex].item,
          viewObjectCreators,
          columnGridObject.settings.columns[columnIndex].rows[rowIndex].panel,
          canvasObject,
          idGenerator,
          item => {
            columnGridObject.addItem(columnIndex, rowIndex, item);
          }
        );
      }
    }
  }

  create(settings) {
    let calllbackArray = this.callbacks.get("beforeCreate");
    calllbackArray.forEach(callback => callback(settings, this));
    ColumnGridCreator.prepareSettings(settings);
    const columnGridObject = new GraphicColumnGrid(settings);
    ColumnGridCreator.createItems(
      settings.columns,
      settings._viewObjectCreators,
      columnGridObject,
      settings._canvasObject,
      settings._idGenerator,
      this
    );
    calllbackArray = this.callbacks.get("afterCreate");
    calllbackArray.forEach(callback => callback(columnGridObject, settings, this));
    return columnGridObject;
  }
}
